const car_accidentRouter = [
  {
      path: "list-car_accident",
      name: "list",
      component: () => import("@/views/admin/car_accident"),
      default: true,
      meta: {
          model: "car_accident",
          // requiresAuth: true,
      },
  },
  {
      path: "list-car_accident/add",
      name: "add",
      component: () => import("@/views/admin/car_accident/function"),
      default: true,
      meta: {
          model: "car_accident",
          // requiresAuth: true,
      },
  },
  {
      path: "list-car_accident/edit/:id",
      name: "edit",
      component: () => import("@/views/admin/car_accident/function"),
      default: true,
      meta: {
          model: "car_accident",
          // requiresAuth: true,
      },
  },
];
export default car_accidentRouter;